export enum MenuSelectedEnum {
  all = "all",
  available = "available",
  unavailable = "unavailable",
}

export interface ActionMenuSelected {
  payload: MenuSelectedEnum;
}